__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "21.2.16", () => (() => (__webpack_require__(3484))), 1);
			register("@angular/common", "21.2.16", () => (() => (__webpack_require__(6444))), 1);
			register("@angular/core", "21.2.16", () => (() => (__webpack_require__(869))), 1);
			register("@angular/forms", "21.2.16", () => (() => (__webpack_require__(8015))), 1);
			register("@angular/platform-browser", "21.2.16", () => (() => (__webpack_require__(8608))), 1);
			register("@angular/router", "21.2.16", () => (() => (__webpack_require__(7477))), 1);
			register("@okta/okta-angular", "6.1.0", () => (() => (__webpack_require__(4568))), 1);
			register("@okta/okta-auth-js", "7.12.1", () => (() => (__webpack_require__(6220))), 1);
			register("exceljs", "4.4.0", () => (() => (__webpack_require__(1259))), 1);
			register("file-saver", "2.0.5", () => (() => (__webpack_require__(3574))), 1);
			register("highcharts-angular", "5.4.1", () => (() => (__webpack_require__(9584))), 1);
			register("moment", "2.30.1", () => (() => (__webpack_require__(2318))), 1);
			register("ngx-daterangepicker-material", "6.0.4", () => (() => (__webpack_require__(4304))), 1);
			register("tslib", "2.8.1", () => (() => (__webpack_require__(9799))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};